<div class="portalnav-wrap por-ac-itemsout">
    @if (appFacadeService.getSubActiveTab() | async; as tab) {
    <div class="portalnav" [ngStyle]="{ height: height, width: width }">
        <div [hidden]="tab !== 'Default'">
            <ng-container [ngTemplateOutlet]="myRentals"></ng-container>
        </div>
        <div [hidden]="tab !== 'ContractDetail'">
            <ng-container [ngTemplateOutlet]="contractDetailTab"></ng-container>
        </div>
        <div [hidden]="tab !== 'ProductDetail'">
            <ng-container [ngTemplateOutlet]="productDetailTab"></ng-container>
        </div>
    </div>
    }
</div>

<ng-template #myRentals>
    <div class="wrapper contract-headingSection">
        <h1 class="theme-heading">{{ 'Items Out Report' | translate }}</h1>
    </div>
    <div id="mainportalpage" class="wrapper">
        <div class="button-group">
            <por-filters
                [singleFilters]="singleFilters"
                [singleFiltersDefaultValue]="singleFiltersDefaultValue"
                [showClearSingleFilter]="false"
                [isProcessing]="(appFacadeService.getLoader() | async) || false"
                (filterOutput)="filter($any($event))"
                (getSingleFilter)="filterByStatus($event)"
                [searchPlaceholder]="filterComponentProps.searchPlaceHolder"
                [dateLabel]="filterComponentProps.dateLabel"
                [startDateLabel]="filterComponentProps.startDateLabel"
                [startDateLabelMobile]="filterComponentProps.startDateLabel"
                [endDateLabel]="'itemsoutEndDateFilter'"
                [disableSearch]="!isSearchSupported"
                (exportCSV)="exportCSV()"
                [uiUrl]="uiUrl"
                [enableExport]="$any(itemsOut$ | async | filterLineItemStatus : lineItemStatusFilter | count) > 0"></por-filters>
        </div>
        <div class="content-wrapper">
            <div class="grid-top-content">
                <!-- Off-Rent only: the click path ANDs Account.RequestCallOff with the org call-off ability,
                     and porFeatureAvailability is any-of — so a RequestService-only user must not see it. -->
                @if (isOffRentAvailable) {
                <div class="button-wrapper">
                    <por-base-button [class]="'theme-button m-order-2'" (click)="getSelectedRowData()" [disabled]="selectionDisabled" [featureName]="'selection-complete-on-itemout-page'">
                        {{ 'OffRent' | translate }}
                    </por-base-button>
                </div>
                }
                <button
                    mat-icon-button
                    type="button"
                    class="instructions-info"
                    [matMenuTriggerFor]="itemsOutInfoMenu"
                    [attr.aria-label]="'instructions' | translate"
                    [matTooltip]="'instructions' | translate"
                    data-testid="por-cp-items-out-info">
                    <mat-icon>info_outline</mat-icon>
                </button>
                <mat-menu #itemsOutInfoMenu="matMenu" class="instructions-menu">
                    <div class="instructions" (click)="$event.stopPropagation()">
                        <p>{{ 'itemOutInstruction1' | translate }}</p>
                        <!-- Describes the Select box, which only exists for the Off-Rent button. -->
                        @if (isOffRentAvailable) {
                        <p>{{ 'itemOutInstruction2' | translate }}</p>
                        }
                        <p>{{ 'itemOutInstruction3' | translate }}</p>
                    </div>
                </mat-menu>
            </div>
            <div class="ag-grid-wrapper">
                @if (gridReadyObservable$ | async) {
                <ag-grid-angular
                    style="width: 100%; height: 100%"
                    class="ag-theme-alpine ag-grid"
                    [columnDefs]="columnDefs"
                    [defaultColDef]="defaultColDef"
                    [rowData]="itemsOut$ | async | filterLineItemStatus : lineItemStatusFilter"
                    [rowHeight]="rowHeight"
                    [headerHeight]="headerHeight"
                    [animateRows]="true"
                    (gridReady)="onGridReady($event)"
                    [isRowSelectable]="isRowSelectable"
                    [rowSelection]="rowSelection"
                    [suppressRowClickSelection]="true"
                    [isFullWidthRow]="isFullWidthRow"
                    [fullWidthCellRenderer]="fullWidthCellRenderer"
                    [context]="context"
                    (selectionChanged)="onSelectionChanged()"
                    (rowDataUpdated)="onRowDataUpdated()"
                    [getRowId]="getRowId"></ag-grid-angular>
                }
            </div>
        </div>
        <div class="middle">
            <por-load-more [hasMoreRecord]="(hasMoreRecord$ | async) ?? false" [featureName]="'load-more-items-out'" (loadMore)="loadMore()"></por-load-more>
        </div>
    </div>
</ng-template>
<ng-template #contractDetailTab>
    @if (appFacadeService.getContractDetail() | async; as contractDetail) {
    <div class="contract-detail wrapper">
        @if (contractDetail) {
        <por-contract-detail (closePanel)="onClosePanelContractDetail()" [customerId]="customerId" [contractDetail]="[contractDetail]" [uiUrl]="inputs?.uiUrl"></por-contract-detail>
        }
    </div>
    }
</ng-template>
<ng-template #productDetailTab>
    @if ((appFacadeService.getProductDetail() | async)?.productDetail) {
    <div class="product-detail wrapper">
        <por-product-detail [uiUrl]="inputs?.uiUrl" (closePanel)="onClosePanelProductDetail()" />
    </div>
    }
</ng-template>
<por-base-modal [id]="'rental-request-page'" [modalWidth]="'modal-xl'" (onclose)="onClosingRequestModal()">
    @if (isRequestModalOpen) {
    <por-rental-request-modal
        [customerId]="customerId"
        [items]="modalItems"
        [totalItems]="modalItems.length"
        [initialView]="requestInitialView"
        [uiUrl]="inputs?.uiUrl"
        (closeModal)="onRequestModalCloseRequested()"
        (callOffRequestInfo)="handleRentalFormSubmission($event)"></por-rental-request-modal>
    }
</por-base-modal>

<por-payment-success-dialog></por-payment-success-dialog>
<por-request-sent-successfully-dialog></por-request-sent-successfully-dialog>
